import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {MaterialModule} from '../../material-module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {DelegationRouting} from './delegation.routing';
import {DelegationListComponent} from './delegation-list/delegation-list.component';
import {MatStepperModule} from '@angular/material';
import {ModalDelegationComponent} from './modal-delegation/modal-delegation.component';
import {SvgIconComponent} from './svg-icon/svg-icon-component';
import {DelegationService} from './delegation.service';
import {ModalEditDelegationComponent} from './modal-edit-delegation/modal-edit-delegation.component';
import {AuthorizationDelegationComponent} from './authorization-delegation/authorization-delegation.component';
import {SelectDelegationComponent} from './select-delegation/select-delegation.component';
import {SearchPipe} from '../../pipe/search.pipe';
import {ModalDeleteDelegationComponent} from './modal-delete-delegation/modal-delete-delegation.component';
import {NgZorroAntdModule} from 'ng-zorro-antd';
import {MomentDateAdapter} from '@angular/material-moment-adapter';

@NgModule({
  declarations: [DelegationListComponent, ModalDelegationComponent, ModalDeleteDelegationComponent, ModalEditDelegationComponent,SvgIconComponent,
    AuthorizationDelegationComponent,
    SelectDelegationComponent,
    SearchPipe],


  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatStepperModule,
    HttpClientModule,
    MaterialModule,
    TranslateModule.forChild(),
    NgZorroAntdModule,
    NgZorroAntdModule
  ],
  entryComponents: [ModalDelegationComponent, ModalEditDelegationComponent, ModalDeleteDelegationComponent, AuthorizationDelegationComponent, SelectDelegationComponent],
  providers: [DelegationService,SearchPipe,MomentDateAdapter],
  exports: [DelegationRouting,SearchPipe]
})
export class DelegationModule {
}




// WEBPACK FOOTER //
// ./src/app/modules/delegation/delegation.module.ts